module.exports = __webpack_public_path__ + "static/bg.5a1e8918.png";